import { Controller } from '@hotwired/stimulus';
import axios from "axios";
import {getMeta} from "../helpers";

export default class extends Controller {
    connect() {
        this.codeSubmitButton = this.element.querySelector('#codeSubmitButton');
        this.codeInput = this.element.querySelector('input[name="code"]');
        this.invitationIDInput = this.element.querySelector('input[name="invitation_id"]');
        this.appliedCouponCode = this.element.querySelector('input[name="applied_coupon_code"]')
        this.formController = Stimulus.getControllerForElementAndIdentifier(this.element, 'axios-form');
        this.currentLanguageCode = getMeta('wp-language').split('-')[0];
        this.type = this.element.querySelector('input[name="type"]');


        if (this.codeInput && this.codeSubmitButton) {
            this.codeInput.addEventListener('input', (e) => {
                if (!e.target.value) {
                    this.appliedCouponCode.value = '';
                }
            });

            this.codeSubmitButton.addEventListener('click', (e) => {
                e.preventDefault();
                if (this.codeInput.value && this.appliedCouponCode.value !== this.codeInput.value) {
                    this.validateCoupon(this.codeInput.code);
                }
            });
        }
    }

    resetCouponCode() {
        this.codeInput.value = '';
        this.appliedCouponCode.value = '';
    }

    validateCoupon(input) {
        if (this.codeSubmitButton.classList.contains('loading')) {
            return;
        }

        this.codeSubmitButton.classList.add('loading');

        this.appliedCouponCode.value = '';
        this.codeInput.disabled = true;
        const url = '/wp-json/api/validate-coupon?rest_language=' + this.currentLanguageCode;

        let formData = new FormData;
        formData.append('code', this.codeInput.value);
        formData.append('type', this.type.value);
        formData.append('invitation_id', this.invitationIDInput.value);

        this.formController.removeFormNotes();

        axios.post(url, formData).then((response) => {
            this.codeInput.disabled = false;
            this.codeSubmitButton.classList.remove('loading');

            response = response.data.data;

            if (response && response.errors && Object.keys(response.errors).length) {
                this.formController.setupFormErrors(response.errors);

            } else if (response && response.general_error) {
                this.formController.setupFormGeneralError(response);

            } else if (response && response.general_success) {
                this.formController.setupFormGeneralSuccess(response);

                if (this.codeInput.value) {
                    if (response.code_type === 'coupon') {
                        this.appliedCouponCode.value = this.codeInput.value;
                    }
                }
            } else if (response && response.redirect) {
                window.location.href = response.redirect;

            } else if (response && response.reload) {
                window.location.reload();

            } else {
                if (!response || !response.action) {
                    this.formController.setupFormUnexpectedError();
                }
            }
        })
    }
}
